<template>
  <div style="padding: 10px">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align:center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
        <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
        </tr> -->
        <Form label-position="left" :label-width="100" style="margin-left:20px">
          <FormItem label="展示数据">
            <Tag :checked="showColumnTitleArray.indexOf(item.title) > -1" v-for="item in columnsbackup" :name="item.title" @on-change="changeColumn" size="medium" checkable color="primary">{{item.title}}</Tag>
          </FormItem>
        </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>
    <Modal v-model="isShowSettingModal" :mask-closable="false" width="450">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>通信参数列表</span>
      </p>
      <Form :model="downObject" label-position="left" :label-width="150">
        <FormItem style="margin-top:-20px" label="IP及端口">
          <Input v-model="downObject.meterIpport" placeholder="输入IP及端口" style="width: 250px" />
        </FormItem>
        <FormItem style="margin-top:-20px" label="表端协议类型">
          <Select v-model="downObject.meterProtocolType" style="width:250px" placeholder="选择表端协议类型">
            <!-- <Option v-if="selectMeterType == 0" value="水表协议 – JP" key="水表协议 – JP">水表协议 – JP</Option>
            <Option v-if="selectMeterType == 0" value="水表协议 – ZP" key="水表协议 – ZP">水表协议 – ZP</Option>
            <Option v-if="selectMeterType == 1" value="热表协议 – JP" key="热表协议 – JP">热表协议 – JP</Option>
            <Option v-if="selectMeterType == 1" value="热表协议 – QY" key="热表协议 – QY">热表协议 – QY</Option>
            <Option v-if="selectMeterType == 2" value="流量计协议 – JP" key="流量计协议 – JP">流量计协议 – JP</Option> -->
            <Option v-for="item in protocolEnum" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem style="margin-top:-20px" label="采集模式">
          <Select v-model="downObject.meterCatchMode" style="width:250px" placeholder="选择采集模式">
            <Option value="周期采集" key="周期采集">周期采集</Option>
            <Option value="定时采集" key="定时采集">定时采集</Option>
          </Select>
        </FormItem>
        <div style="margin-top:-20px" v-if="downObject.meterCatchMode == '周期采集'">
          <FormItem label="采集间隔(分钟)">
            <Input v-model="downObject.meterCatchInterval" placeholder="取值范围10~1440" style="width: 250px" />
          </FormItem>
        </div>
        
        <div style="margin-top:-20px" v-if="downObject.meterCatchMode == '定时采集'">
          <span style="color:red">例：012015表示每月1号20:15采集。若填写000000则表示不设置</span>
          <FormItem label="定时采集时间1">
            <Input v-model="downObject.meterCatchInterval1" placeholder="输入定时采集时间1" style="width: 250px" />
          </FormItem>
          <FormItem style="margin-top:-20px" label="定时采集时间2">
            <Input v-model="downObject.meterCatchInterval2" placeholder="输入定时采集时间2" style="width: 250px" />
          </FormItem>
          <FormItem style="margin-top:-20px" label="定时采集时间3">
            <Input v-model="downObject.meterCatchInterval3" placeholder="输入定时采集时间3" style="width: 250px" />
          </FormItem>
          <FormItem style="margin-top:-20px" label="定时采集时间4">
            <Input v-model="downObject.meterCatchInterval4" placeholder="输入定时采集时间4" style="width: 250px" />
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
          <Button style="margin-right:38%" :loading="downing" type="primary" @click="downSetting">提交下发</Button>
      </div>
    </Modal>
    <div style="background: #fff; border-radius: 8px; padding: 20px;">
      <div class="query-c">
        <Row style="white-space:nowrap;">
           <Col span="24" style="padding:2px;margin:2px;border-radius: 25px;">
            <Select
                clearable
                v-model="searchObject.meterType"
                style="width:8%;margin-right: 5px"
                placeholder="选择表具类型"
            >
                <!-- <Option value="水表" key="水表">水表</Option> -->
                <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{ item }}</Option>
            </Select>
            <!-- <Input v-model="searchObject.userAccount" placeholder="输入用户账号(模糊查询)" style="width: 200px;margin-right: 5px" /> -->
            <Select
                clearable
                filterable
                v-model="searchObject.userAccount"
                style="width:20%;margin-right: 5px"
                placeholder="选择客户"
            >
                <Option v-for="item in userList" v-if="getMeterType(item.userMeterType).indexOf(searchObject.meterType) > -1 " :value="item.userAccount" :key="item.userAccount">{{
                    item.userName
                }}</Option>
            </Select>
            <DatePicker
                v-show="false"
                :options="optionsDisabled"
                v-model="searchObject.meterBirth"
                type="date"
                placeholder="出厂日期"
                style="width: 12%;margin-left:5px"
            ></DatePicker>
            <Select
                clearable
                filterable
                placeholder="选择表具口径"
                v-model="searchObject.meterCaliber"
                style="width:10%;margin-left:5px"
            >
                <Option v-for="item in caliberEnum" :value="item" :key="item">{{ item }}</Option>
            </Select>
                    
            <!-- <DatePicker
                v-model="searchObject.startDate"
                type="date"
                placeholder="起始日期"
                style="width: 12%;margin-left:5px"
            ></DatePicker>
            <DatePicker
                v-model="searchObject.endDate"
                type="date"
                placeholder="结束日期"
                style="width: 12%;margin-left:5px"
            ></DatePicker> -->
            <Input v-model="searchObject.meterAddress" placeholder="输入表具地址" style="width: 16%;margin-left: 5px" />
            <i-switch style="margin-left:3px;float:right" v-model="openCheckTime" true-color="#13ce66" false-color="#ff4949" @on-change="changeCheck">
                <span slot="open">开</span>
                <span slot="close">关</span>
            </i-switch>
            <span style="margin-left:5px;float:right">自动校时</span>

            <Button style="margin-left:5px;float:right;width: 6%;" type="primary" @click="showSetting">参数设置</Button>
            <Button style="margin-left:5px;float:right" type="primary" @click="isShowSetModal = true" >显示项设置</Button>
            <Button style="margin-left:5px;float:right;width: 6%;" type="primary" icon="ios-search" @click="showPage">查询</Button>
        </Col>
          <!-- <Col span="8" style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;">
          <div style="margin-left:2%;">
            <br/>
            <div>
              <Select clearable v-model="searchObject.meterType" style="width:32%;margin-right: 5px" placeholder="选择表具类型">
                <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{item}}</Option>
              </Select>
              
              <Select clearable filterable placeholder="选择表具口径" v-model="searchObject.meterCaliber" style="width:32%;;margin-right:5px">
                <Option v-for="item in caliberEnum" :value="item" :key="item">{{ item }}</Option>
              </Select>
               <Button style="width:32%" type="primary" icon="ios-search" @click="showPage">查询</Button>

            </div>
            <div style="margin-top:5px">
                <Select clearable filterable v-model="searchObject.userAccount" style="width:32%;margin-right: 5px" placeholder="选择客户名称">
                    <Option v-for="item in userList" :value="item.userAccount" :key="item.userAccount">{{item.userName}}</Option>
                </Select>
                <Input v-model="searchObject.meterAddress" placeholder="输入表具地址" style="width: 32%;margin-right: 5px" />
               
            </div>
            <br/>
          </div>
          </Col> -->
          <!-- <Col span="3" style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;">
            <br/>
            <div style="margin-left:15%">
              
              
            </div>
            <div style="margin-left:10%;margin-top:15px;width: 80%">
              <span style="width: 46%;margin-left: 4%">自动校时：</span>
              <i-switch style="width: 48%;margin-left: 5px" v-model="openCheckTime" true-color="#13ce66" false-color="#ff4949" @on-change="changeCheck">
                  <span slot="open">开</span>
                  <span slot="close">关</span>
              </i-switch>
            </div>
            <br/>
          </Col> -->

        </Row>
        <!-- <Row style="white-space:nowrap;">
            <Col span="24" style="padding:2px;margin:2px;border-radius: 25px;">
                <i-switch style="margin-left:3px;float:right" v-model="openCheckTime" true-color="#13ce66" false-color="#ff4949" @on-change="changeCheck">
                    <span slot="open">开</span>
                    <span slot="close">关</span>
                </i-switch>
                <span style="margin-left:5px;float:right">自动校时</span>

                <Button style="margin-left:5px;float:right;width: 6%;" type="primary" @click="showSetting">参数设置</Button>
            </Col>
        </Row> -->
      </div>
      <br />
      <Table @on-selection-change="selectRow" size="small" :height="tableHeight" border stripe :columns="columns" :data="data" highlight-row></Table>
      <br />
      <!-- <Page :total="100" show-sizer show-elevator /> -->
        
      </div>
    </div>
    
  </div>
</template>

<script>
  export default {
    name: "downsetting",
    data() {
      var that = this;
      return {
        dateArray: [],
        optionsDisabled: {
            disabledDate (date) {
                return date && that.dateArray.indexOf(global.dateFtt("yyyy-MM-dd", date)) == -1;
            }
        },
        pageName: "downsetting",
        meterTypeEnum: global.meterType(),
        caliberEnum: [],
        downObject: {
            meterCatchInterval1: "000000",
            meterCatchInterval2: "000000",
            meterCatchInterval3: "000000",
            meterCatchInterval4: "000000",
            meterCatchMode: "周期采集",
            meterCatchInterval: "1440",
            meterIpport: "47.105.210.255:12370"
        },
        meterTList: [{
            value: 0,
            label: '水表'
          },
          {
            value: 1,
            label: '热表'
          },
          {
            value: 2,
            label: '流量表'
          }
        ],
        showColumnTitleArray: [],
        columnsbackup: [
            {
                title: '选择',
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                title: "序号",
                type: 'index',
                width: 100,
                align: 'center'
            },
            {
              title: '客户账号',
              key: 'userAccount',
              resizable: true,
              width: 160
            },
            {
              title: '客户名称',
              key: 'userName',
              resizable: true,
              width: 160
            },
            {
              title: '表具类型',
              key: 'meterType',
              resizable: true,
              width: 160
            },
            {
              title: '表具地址',
              key: 'meterAddress',
              resizable: true,
              width: 160
            },
            {
              title: '口径',
              key: 'meterCaliber',
              resizable: true,
              width: 100
            }
          ],
        selectMeterType: 0,
        tableHeight: '200',
        addressfield1: "",
        addressfield2: "",
        addressfield3: "",
        addressfield4: "",
        addressfield5: "",
        downing: false,
        meterReadingSum: 0.0,
        userList: [],
        warnCount: {},
        abnormal: 0,
        normal: 0,
        warnType: "",
        openCheckTime: false,
        searchObject: {
            meterType: '水表'
        },
        // meterArray: ["00000018003155", "00000018004345", "00000018004361", "00000018004457", "00000018004523",
        //   "00000018004635", "00000018004782", "00000018004789", "00000018004798", "00000018004799", "00000018004850",
        //   "00000018005048", "00000018005051", "00000018005064", "00000018005332", "00000018005388", "00000018005401",
        //   "00000018005405", "00000018005456", "00000018005462"
        // ],
        meterArray: [],
        meterArray1: ["00000018003155", "00000018004361", "00000018004457", "00000018004523",
          "00000018004798",  "00000018005064", "00000018005332", "00000018005401",
          "00000018005456", "00000018005462", "11110000000000"
        ],
        meterArray2:["00000018005405","00000018004345","00000018004799"],
        addressObject: {},
        stateContrast: global.stateContrast,
        meterAddress: "",
        stateArray: {},
        isShowStateModal: false,
        isShowSettingModal: false,
        isShowSetModal: false,
        selectedRow: [],
        columns: [
            {
                title: '选择',
                type: 'selection',
                width: 60,
                align: 'center'
            },
            {
                title: "序号",
                type: 'index',
                width: 100,
                align: 'center'
            },
            {
              title: '客户账号',
              key: 'userAccount',
              resizable: true,
              width: 160
            },
            {
              title: '客户名称',
              key: 'userName',
              resizable: true,
              width: 160
            },
            {
              title: '表具类型',
              key: 'meterType',
              resizable: true,
              width: 160
            },
            {
              title: '表具地址',
              key: 'meterAddress',
              resizable: true,
              width: 160
            },
            {
              title: '口径',
              key: 'meterCaliber',
              resizable: true,
              width: 100
            }
          ],
        data: [],
        protocolEnum: []
      };
    },
    methods: {
      getMeterType(type){
          return global.getMeterType(type);
      },
      getMeterCaliberEnum(){
        var that = this;
        that.$axios.post('/api/meter/getMeterCaliberEnum', {}).then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          
          that.caliberEnum = data.body;
          that.caliberEnum.sort(function(a,b){
            return parseInt(a.replace("DN", "")) - parseInt(b.replace("DN", ""));
          });
        }).catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        }).finally(() => {
          // that.showPage();
        });
      },
      getMeterProtocolEnum(){
        var that = this;
        that.$axios.post('/api/meter/getMeterProtocolEnum', {}).then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          
          that.protocolEnum = data.body;
        }).catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        }).finally(() => {
          // that.showPage();
        });
      },
        getCheckState(){
            var that = this;
            this.$axios.post('/api/meterdetailed/getCheckTime', {}).then(function(data) {
                console.log(data);
                if (data.errorCode != 0) {
                    that.$Notice.error({
                        title: "异常",
                        desc: data.errorInfo
                    });
                    return;
                }
                
                that.openCheckTime = data.body.state;
                console.log(that.openCheckTime);
            })
            .catch(function(error) {
                console.log(error);
            }).finally(() => {
            });
        },
        changeCheck () {
            var that = this;
            that.$axios.post('/api/meterdetailed/changeCheckTime', {}).then(function(data) {
                console.log(data);
                if (data.errorCode != 0) {
                    that.$Notice.error({
                        title: "异常",
                        desc: data.errorInfo
                    });
                    return;
                }
                
                // that.openCheckTime = data.body.state;
                resolve();
                // console.log(that.openCheckTime);
                that.$Notice.success({
                    title: "提示",
                    desc: "切换成功!"
                });
            })
            .catch(function(error) {
                console.log(error);
            }).finally(() => {
            });
        },
      showSetting(){
          if(this.selectedRow.length == 0){
              this.$Modal.info({
                title: "提示",
                content: "至少选择一个设备！"
            });
            return;
          }
          this.downObject = this.selectedRow[0];
          this.isShowSettingModal = true;
      },
      downSetting(){
        var warnStr = "";

        if(this.downObject.meterCatchInterval == undefined || this.downObject.meterCatchInterval == "" || this.downObject.meterCatchInterval < 10 || this.downObject.meterCatchInterval > 1440){
            warnStr = "填写正确的采集间隔，取值范围为10~1440，单位：分钟";
        }
        if(this.downObject.meterProtocolType == undefined || this.downObject.meterProtocolType == ""){
            warnStr = "选择表端协议类型";
        }
        if(this.downObject.meterIpport == undefined || this.downObject.meterIpport == ""){
            warnStr = "填写正确的IP及端口";
        }

        if(warnStr != ""){
            this.$Notice.info({
                title: "提示",
                desc: warnStr
            });
            return;
        }
        var that = this;
        this.downing = true;
        this.isShowSettingModal = false;
        that.downObject.meterArray = JSON.parse(JSON.stringify(that.selectedRow));
        that.$axios.post('/api/message/downParamMessage', that.downObject).then(function(data) {
            console.log(data);
            if (data.errorCode != 0) {
                that.$Notice.error({
                    title: "异常",
                    desc: data.errorInfo
                });
                return;
            }

            that.$Notice.success({
                title: "提示",
                desc: "已下发至指令队列！"
            });
          })
          .catch(function(error) {
            console.log(error);
          }).finally(() => {
              this.downing = false;
          });
      },
      selectRow(selection, row){
        this.selectedRow = selection;
      },
      getUserList() {
        var that = this;
        that.$axios.post('/api/user/getUserList', {}).then(function(res) {
            console.log(res);
            that.userList = res.body;
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      generateColumnTitleArray(){
        let titleArray = [];

        for(let i = 0; i < this.columnsbackup.length; i ++){
          titleArray.push(this.columnsbackup[i].title);
        }

        this.showColumnTitleArray = titleArray;
        if(localStorage.getItem(this.pageName + localStorage.getItem('userAccount')) != undefined){
          this.showColumnTitleArray  = JSON.parse(localStorage.getItem(this.pageName + localStorage.getItem('userAccount')));
          var showArray = [];
          for(let i = 0; i < this.columnsbackup.length; i ++){
            let currentObject = this.columnsbackup[i];
            if(this.showColumnTitleArray.indexOf(currentObject.title) > -1){
              showArray.push(currentObject);
            }
          }

          this.columns = showArray;
        }
      },
      getAddressEnum(){
        var that = this;
        that.$axios.post('/api/dictionary/selectAddressEnum', {
        }).then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          
          that.addressObject = data.body;
        }).catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        }).finally(() => {
        });
      },
      parseDate(str) {
        var year = str.substr(0, 4);
        var month = str.substr(4, 2);
        var day = str.substr(6, 2);
        var hour = str.substr(8, 2);
        var minute = str.substr(10, 2);
        var second = str.substr(12, 2);
        return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
      },
      onClickSearch() {
        this.showPage();
      },
      showState(row) {
        this.isShowStateModal = true;
        this.stateArray = JSON.parse(row.messageContent).decode.state;
      },
      showStateStr(row) {
        let stateArray = JSON.parse(row.messageContent).decode.state;
        let that = this;
        let stateStr = "";
        Object.keys(stateArray).forEach(function(key) {
          if (stateArray[key] == that.stateContrast[key]) {
            stateStr = stateStr +  key + " " + that.stateContrast[key] + "; ";
          }
        });

        return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
      },
      changeColumn(checked, name){
        if(checked){
          this.showColumnTitleArray.push(name);
        }else{
          this.showColumnTitleArray.splice(this.showColumnTitleArray.indexOf(name), 1);
        }

        var showArray = [];

        for(let i = 0; i < this.columnsbackup.length; i ++){
          let currentObject = this.columnsbackup[i];
          if(this.showColumnTitleArray.indexOf(currentObject.title) > -1){
            showArray.push(currentObject);
          }
        }

        localStorage.setItem(this.pageName + localStorage.getItem('userAccount'), JSON.stringify(this.showColumnTitleArray));

        this.columns = showArray;
      },
      getCurrentMeterType(){
        let meterType = "";

        for(let i = 0; i < this.meterTList.length; i ++){
            let temp = this.meterTList[i];

            if(temp.value == this.selectMeterType){
                meterType = temp.label;
                break;
            }
        }

        return meterType;
      },
      showPage() {
        var that = this;
        // if(that.searchObject.userAccount == undefined || that.searchObject.userAccount == ""){
        //     that.$Modal.info({
        //         title: "提示",
        //         content: "先选择客户！"
        //     });
        //     return;
        // }
        if(that.searchObject.startDate){
          that.searchObject.endDate = new Date(global.dateFtt("yyyy-MM-dd", searchParam.startDate) + " 23:59:59");
        }
        
        that.data = [];
        that.$axios.post('/api/meterdetailed/getMeterDetailedList', that.searchObject).then(function(data) {
            console.log(data);
            

            that.data = data.body;
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      async getMeterArray(){
        var that = this;
        that.$axios.post('/api/meter/selectMeterList', {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5
        }).then((data) => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          
          that.meterArray = data.body;

          that.showPage();
          console.log(data.body);
        }).catch((error) => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        }).finally(() => {
        });
      }
    },
    mounted() {
      // this.showPage();
      let that = this;
      window.addEventListener('resize', function() {
        that.tableHeight = (window.innerHeight - 186) * 0.8;
      })
      that.tableHeight = (window.innerHeight - 186) * 0.8;

      that.generateColumnTitleArray();
    //   that.getMeterArray();
      that.getAddressEnum();
      that.getUserList();
      that.getMeterCaliberEnum();
      that.getCheckState();
      that.getMeterProtocolEnum();
      that.$axios
      .post("/api/meterdetailed/getMeterBirthList", that.searchObject)
      .then(function(res) {
          that.dateArray = res.body;
      })
      .catch(function(error) {
          console.log(error);
      });
    },
    watch: {
    }
  };
</script>

<style scoped>
</style>
